import React from 'react';

const TransportationServiceSection = () => {
  return (
    <section className="px-6 md:px-20 lg:px-40 py-12 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-sm text-red-600 font-semibold">PERSONEL TAŞIMACILIĞI</p>
        <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mt-2">
          Ankara Personel Taşımacılık Hizmetlerimiz
        </h2>
        <p className="text-gray-500 text-base md:text-lg mt-4">
          Ankara’da personel taşımacılığı konusundaki uzmanlığımızla, işletmelerin 
          personelini güvenli ve sorunsuz bir şekilde taşıyoruz. Ankara’nın karmaşık trafik koşullarına 
          ve şehrin dinamik yapısına hakim olan deneyimli şöförlerimiz, personelinizin işe zamanında 
          ve güvenle ulaşmasını sağlar.
        </p>
      </div>
    </section>
  );
};

export default TransportationServiceSection;
